import React__default, { Suspense } from 'react';
import PT from 'prop-types';
import { E as ErrorBoundary } from './ErrorBoundary-c2204b12-698039b2.js';
import { I as InternalIntlProvider } from './Provider-364caeae-5bd675a3.js';

function isDynamicComponent(translations) {
  return 'translationImports' in translations && translations.translationImports;
}
function IntlProvider({
  children,
  resetKey,
  fallback,
  translations,
  onError,
  onReset
}) {
  return isDynamicComponent(translations) ? /*#__PURE__*/React__default.createElement(ErrorBoundary, {
    resetKey: resetKey,
    onError: onError,
    onReset: onReset
  }, /*#__PURE__*/React__default.createElement(Suspense, {
    fallback: fallback !== null && fallback !== void 0 ? fallback : null
  }, /*#__PURE__*/React__default.createElement(InternalIntlProvider, {
    translations: translations
  }, children))) : /*#__PURE__*/React__default.createElement(InternalIntlProvider, {
    translations: translations
  }, children);
}
IntlProvider.propTypes = {
  fallback: PT.node
};
IntlProvider.defaultProps = {
  fallback: null
};

export { IntlProvider as I };
//# sourceMappingURL=IntlProvider-32f3f4a3-545e9b0f.js.map
